import { z } from 'zod';
import { SORT_BY_OPTION_VALUES } from '@axiom/const';

import { TalentSearchDisplayFiltersCategorySchema } from './talent-search-display-filters-category';

export const TalentSearchDisplayFiltersSchema = z.object({
  categories: z.array(TalentSearchDisplayFiltersCategorySchema),
  hasSearched: z.boolean().nullish(),
  search: z.string().nullish(),
  sort: z.enum(SORT_BY_OPTION_VALUES).nullish(),
});

export type TalentSearchDisplayFilters = z.infer<
  typeof TalentSearchDisplayFiltersSchema
>;
